import React, { useEffect, useState } from "react";
import {
  TreeAPI,
  NodeCopyAPI,
  NodeDeleteAPI,
  SetCopyAPI,
  SetDeleteAPI,
  SqlAPI,
} from "../services/api";
import { useSession } from "../context/SessionContext";
import {
  ChevronDown,
  ChevronRight,
  Copy,
  Pencil,
  Trash2,
  Workflow,
  Tag,
  Summary,
} from "lucide-react";

interface TreeNode {
  text: string;
  tag: number;
  color: string;
  children: TreeNode[];
  wbsNo?: number;
  notationNo?: number;
   notationHead?: number;
    sequence?: number;   // ✅ Add this
}

interface Props {
  projectId: number;
  refresh?: number;
  onSelect?: (node: TreeNode) => void;
}

 const getNodeColor = (node: TreeNode) => {
  //return node.tag > 0 ? "text-black" : "text-blue-600";
 return node.tag > 0 ? "text-black" : "text-[#6E8CA0]";
  
 
}; 

const getIcon = (isSelected: boolean, isNotation: boolean) => {
  const color = isSelected ? "text-indigo-700" : "text-indigo-500";

  if (isNotation) {
   // return <Tag size={14} className="text-blue-500" />;
   return <Tag size={14} className="text-[#3F5F82]" />
  }

  return <Workflow size={16} className={color} />;
};

const getNodeKey = (node: TreeNode) => {
  if (node.tag === 0 && !node.wbsNo && !node.notationNo) return "root";

  if (node.tag > 0) {
    return `wbs-${node.wbsNo ?? node.tag}`;
  }

  return `not-${node.notationNo ?? Math.abs(node.tag)}`;
};

const findNode = (
  node: TreeNode,
  key: string
): TreeNode | null => {
  if (getNodeKey(node) === key) return node;

  for (const child of node.children || []) {
    const found = findNode(child, key);
    if (found) return found;
  }

  return null;
};



const AccordionNode = ({
  node,
  level = 0,
  onSelect,
  selectedTag,
  reloadTree,
  projectId,
  sessionNo,
  openNodes,
  setOpenNodes,
}: {
  node: TreeNode;
  level?: number;
  onSelect?: (node: TreeNode) => void;
  selectedTag: number | null;
  reloadTree?: () => void;
  projectId: number;
  sessionNo: number | null;
  openNodes: Record<string, boolean>;
  setOpenNodes: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}) => {
 /*  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(node.text);
 */
const [isEditing, setIsEditing] = useState(false);
const [editValue, setEditValue] = useState(node.text);
const [saving, setSaving] = useState(false);

  const hasChildren = node.children?.length > 0;
  const isSelected = selectedTag === node.tag;
  const isWBS = node.tag > 0;
  const isNotation = node.tag < 0;
  const isRootNode = node.tag === 0 && !node.wbsNo && !node.notationNo;

  const nodeKey = getNodeKey(node);
  const open = !!openNodes[nodeKey];

  useEffect(() => {
    setEditValue(node.text);
  }, [node.text]);

  const updateNodeName = async (treeNodeNo: number, newName: string) => {
    return await SqlAPI.update("WorkTree", "TreeNodeNo", {
      TreeNodeNo: treeNodeNo,
      WorkTreeName: newName,
    });
  };

 /*  const saveEdit = async () => {
    const trimmed = editValue.trim();

    if (!trimmed) {
      alert("Name cannot be empty");
      return;
    }

    try {
      let res;

      if (node.tag > 0) {
        res = await updateNodeName(node.tag, trimmed);
      } else {
        if (!node.notationNo) {
          alert("Invalid Notation");
          return;
        }

        res = await SqlAPI.update("Notations", "NotationNo", {
          NotationNo: node.notationNo,
          Notation: trimmed,
        });
      }

      const rows = res?.rowsAffected ?? res?.RowsAffected ?? 0;

      if (rows === 0) {
        alert("Update failed");
        return;
      }

      node.text = trimmed;
      setIsEditing(false);
      reloadTree && reloadTree();
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  }; */
  const saveEdit = async () => {
  if (saving) return;

  const trimmed = editValue.trim();

  if (!trimmed) {
    alert("Name cannot be empty");
    return;
  }

  setSaving(true);

  try {
    let res;

    if (node.tag > 0) {
      res = await updateNodeName(node.tag, trimmed);
    } else {
      if (!node.notationNo) {
        alert("Invalid Notation");
        return;
      }

      res = await SqlAPI.update("Notations", "NotationNo", {
        NotationNo: node.notationNo,
        Notation: trimmed,
      });
    }

    console.log("Update Response:", res);

    const rows = Array.isArray(res?.rowsAffected)
      ? res.rowsAffected[0]
      : res?.rowsAffected ??
        res?.RowsAffected ??
        0;

    if (rows <= 0) {
      alert("Update failed");
      return;
    }

    setIsEditing(false);

    reloadTree?.();
  } catch (err) {
    console.error("UPDATE ERROR:", err);
    alert("Update failed");
  } finally {
    setSaving(false);
  }
};

  const handleEditClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    setIsEditing(true);
    setEditValue(node.text);
  };

  const handleWbsCopy = async (e?: React.MouseEvent) => {
    e?.stopPropagation();

    try {
      if (!sessionNo) {
        alert("Session not ready");
        return;
      }

      await NodeCopyAPI.copy(node.tag, sessionNo);
      alert("Copied successfully");
      reloadTree && reloadTree();
    } catch (err: any) {
      console.error("COPY ERROR:", err);
      alert(err?.response?.data || "Copy failed");
    }
  };

  const handleWbsDelete = async (e?: React.MouseEvent) => {
    e?.stopPropagation();

    if (!window.confirm("Delete this WBS?")) return;

    try {
      if (!sessionNo) {
        alert("Session not ready");
        return;
      }

      await NodeDeleteAPI.remove(node.tag, sessionNo);
      alert("Deleted successfully");
      reloadTree && reloadTree();
    } catch {
      alert("Delete failed");
    }
  };

  const handleNotationDuplicate = async (e?: React.MouseEvent) => {
    e?.stopPropagation();

    try {
      if (!sessionNo) {
        alert("Session not ready");
        return;
      }

      await SetCopyAPI.duplicate(Math.abs(node.tag), projectId, sessionNo);
      alert("Notation duplicated successfully");
      reloadTree && reloadTree();
    } catch (err: any) {
      console.error("DUPLICATE ERROR:", err);

      const message =
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.message ||
        "Duplicate failed";

      alert(message);
    }
  };

  const handleNotationDelete = async (e?: React.MouseEvent) => {
    e?.stopPropagation();

    if (!window.confirm("Delete this Notation?")) return;

    try {
      const setno = Math.abs(node.tag);

      if (!sessionNo) {
        alert("Session not ready");
        return;
      }

      await SetDeleteAPI.remove(setno, sessionNo);
      alert("Notation deleted successfully");
      reloadTree && reloadTree();
    } catch (err) {
      console.error(err);
      alert("Delete failed");
    }
  };

  const handleCopy = async (e?: React.MouseEvent) => {
    if (isWBS) {
      await handleWbsCopy(e);
    } else {
      await handleNotationDuplicate(e);
    }
  };

  const handleDelete = async (e?: React.MouseEvent) => {
    if (isWBS) {
      await handleWbsDelete(e);
    } else {
      await handleNotationDelete(e);
    }
  };

  return (
    <div style={{ paddingLeft: `${level * 10}px` }}>
      <div
        className={`group relative flex items-center rounded-md px-1 py-0.5 ${
          /* isSelected
            ? "bg-indigo-100 text-indigo-700 font-semibold"
            : "hover:bg-indigo-50" */
            isSelected
  /* ? "bg-indigo-100 text-indigo-700"
  : "hover:bg-indigo-50" */
   ? "bg-[#f0f0ff] text-black"
    : "hover:bg-[#f0f0ff]"
        }`}
      >
        {hasChildren ? (
          <button
           /*  onClick={(e) => {
              e.stopPropagation();
              setOpenNodes((prev) => ({
                ...prev,
                [nodeKey]: !prev[nodeKey],
              }));
            }} */
           onClick={(e) => {
  e.stopPropagation();

  setOpenNodes((prev) => {
    const updated = {
      ...prev,
      [nodeKey]: !prev[nodeKey],
    };

    sessionStorage.setItem(
      `treeOpenNodes-${projectId}`,
      JSON.stringify(updated)
    );

    return updated;
  });
}}
            className="w-4 h-4 flex items-center justify-center shrink-0 text-gray-600"
            title={open ? "Collapse" : "Expand"}
            aria-label={open ? "Collapse" : "Expand"}
          >
            {open ? (
              <ChevronDown size={14} strokeWidth={2} className="text-gray-600" />
            ) : (
              <ChevronRight size={14} strokeWidth={2} className="text-gray-600" />
            )}
          </button>
        ) : (
          <span className="w-4 h-4 shrink-0" />
        )}

        <div
          className="flex flex-1 min-w-0 items-center cursor-pointer"
          onClick={() => {
           /*  if (hasChildren) {
              setOpenNodes((prev) => ({
                ...prev,
                [nodeKey]: !prev[nodeKey],
              }));
            } */
           if (hasChildren) {
  setOpenNodes((prev) => {
    const updated = {
      ...prev,
      [nodeKey]: !prev[nodeKey],
    };

    sessionStorage.setItem(
      `treeOpenNodes-${projectId}`,
      JSON.stringify(updated)
    );

    return updated;
  });
}
            onSelect && onSelect(node);
          }}
        >
          <div className="flex items-center gap-1 min-w-0">
            {/* {getIcon(isSelected, isNotation)} */}

            {isEditing ? (
              <input
                value={editValue}
                autoFocus
                onFocus={(e) => e.target.select()}
                onChange={(e) => setEditValue(e.target.value)}
                onClick={(e) => e.stopPropagation()}
               /*  onBlur={async () => {
                  await saveEdit();
                }}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await saveEdit();
                  }
                  if (e.key === "Escape") {
                    setIsEditing(false);
                  }
                }} */
               onBlur={saveEdit}
onKeyDown={(e) => {
  if (e.key === "Enter") {
    e.currentTarget.blur();
  }

  if (e.key === "Escape") {
    setIsEditing(false);
  }
}}
                //className="text-sm border px-1 rounded outline-none min-w-0"
                className="border px-1 rounded outline-none min-w-0"
style={{
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "13px",
  fontWeight: 400,
}}
              />
            ) : (
              <span
                /* className={`text-sm min-w-0 whitespace-nowrap overflow-hidden text-ellipsis block ${getNodeColor(
                  node
                )}`} */
                className={`min-w-0 whitespace-nowrap overflow-hidden text-ellipsis block ${getNodeColor(node)}`}
style={{
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "13px",
  fontWeight: 400,
}}
              >
                {node.text}
              </span>
            )}

            {/* <span className="text-xs text-gray-500 whitespace-nowrap shrink-0"> */}
          <span  className="text-gray-500 whitespace-nowrap shrink-0"
style={{
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "13px",
  fontWeight: 400,
}}>
              {/* {node.tag > 0 ? `WBS: ${node.wbsNo}` : `Notation: ${node.notationNo}`} */}
            </span>
          </div>
        </div>

        {!isRootNode && (
          <div
            className="ml-2 flex items-center gap-1 shrink-0 overflow-hidden opacity-0 max-w-0 pointer-events-none transition-all duration-200 group-hover:opacity-100 group-hover:max-w-[260px] group-hover:pointer-events-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleEditClick}
              className="p-1 bg-gray-100 text-black hover:bg-gray-200 rounded"
              title="Rename"
              aria-label="Rename"
            >
             { <Pencil size={14} /> }
            
            </button>

            {isWBS && (
              <button
                onClick={() => {
                  if (!node.wbsNo) {
                    alert("Invalid WBS");
                    return;
                  }
                  window.open(`/boq/${node.wbsNo}`, "_blank");
                }}
               // className="text-xs px-2 py-0.5 bg-blue-500 text-white rounded hover:bg-blue-600"
               //className="px-2 py-0.5 bg-blue-500 text-white rounded hover:bg-blue-600"
               className="p-1 bg-gray-100 text-black hover:bg-gray-200 rounded"
style={{
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "13px",  
  fontWeight: 400,
}}
                title="BOQ"
              >
             <Summary size={14} color="black" />
              </button>
            )}

            <button
              onClick={handleCopy}
              className="p-1 bg-gray-100 text-black hover:bg-gray-200 rounded"
              title="Copy"
              aria-label="Copy"
            >
              <Copy size={14} />
            </button>

            <button
              onClick={handleDelete}
              className="p-1 bg-gray-100 text-black hover:bg-gray-200 rounded"
              title="Delete"
              aria-label="Delete"
            >
              <Trash2 size={14} />
            </button>
          </div>
        )}
      </div>

      {open && hasChildren && (
        <div>
           {node.children.map((child, index) => (
            <AccordionNode
             // key={`${child.tag}-${child.notationNo ?? 0}-${index}`}
             key={getNodeKey(child)}
              node={child}
              level={level + 1}
              onSelect={onSelect}
              selectedTag={selectedTag}
              reloadTree={reloadTree}
              projectId={projectId}
              sessionNo={sessionNo}
              openNodes={openNodes}
              setOpenNodes={setOpenNodes}
            />
          ))} 
         
        </div>
      )}
    </div>
  );
};

const TreeView = ({ projectId, refresh, onSelect }: Props) => {
  const [tree, setTree] = useState<TreeNode | null>(null);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState<number | null>(null);
  const [selectedNodeKey, setSelectedNodeKey] = useState<string | null>(null);

  const [openNodes, setOpenNodes] = useState<Record<string, boolean>>({});

  useEffect(() => {
  const savedOpenNodes = sessionStorage.getItem(
    `treeOpenNodes-${projectId}`
  );

  if (savedOpenNodes) {
    setOpenNodes(JSON.parse(savedOpenNodes));
  }
}, [projectId]);
  const { sessionNo } = useSession();

  useEffect(() => {
    console.log("Session:", sessionNo);
  }, [sessionNo]);

  const loadTree = () => {
    setLoading(true);

    TreeAPI.getTree(projectId)
      .then(setTree)
      .catch(() => alert("Failed to load tree"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadTree();
  }, [projectId, refresh]);
 


/* useEffect(() => {
  if (!tree) return;

  const rootKey = getNodeKey(tree);

  setOpenNodes((prev) => ({
    ...prev,
    [rootKey]: true,
  }));

  if (selectedNodeKey) {
    const node = findNode(tree, selectedNodeKey);

    if (node) {
      setSelectedTag(node.tag);
      onSelect?.(node);
      return;
    }
  }

  setSelectedTag(tree.tag);
  onSelect?.(tree);
}, [tree, selectedNodeKey]);
 */
useEffect(() => {
  if (!tree) return;

  const rootKey = getNodeKey(tree);

  setOpenNodes((prev) => ({
    ...prev,
    [rootKey]: true,
  })); 
 


  
  const savedKey =
    selectedNodeKey ??
    sessionStorage.getItem(`treeSelection-${projectId}`);

  if (savedKey) {
    const node = findNode(tree, savedKey);

    if (node) {
      setSelectedTag(node.tag);
      setSelectedNodeKey(savedKey);
      onSelect?.(node);
      return;
    }
  }

  setSelectedTag(tree.tag);
  onSelect?.(tree);
}, [tree, selectedNodeKey, projectId]);

 /*  const handleSelect = (node: TreeNode) => {
    setSelectedTag(node.tag);

    if (node.tag > 0) {
      console.log("WBS No:", node.wbsNo);
    } else {
      console.log("Notation No:", node.notationNo);
    }

    onSelect && onSelect(node);
  };  */
  const handleSelect = (node: TreeNode) => {
  setSelectedTag(node.tag);
  setSelectedNodeKey(getNodeKey(node));

   // Save the selected node
  sessionStorage.setItem(
    `treeSelection-${projectId}`,
    getNodeKey(node)
  );

  if (node.tag > 0) {
    console.log("WBS No:", node.wbsNo);
  } else {
    console.log("Notation No:", node.notationNo);
  }

  onSelect?.(node);
};
 

  //if (loading) return <p>Loading...</p>;
  if (loading)
  return (
    <p
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      Loading...
    </p>
  );

  return (
    // <div className="thin-scrollbar h-full w-full overflow-y-auto bg-transparent p-1">
    // <div className="thin-scrollbar h-full w-full overflow-y-scroll bg-transparent p-1">
    <div
  className="thin-scrollbar h-full w-full overflow-y-scroll bg-transparent p-1"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>
   
      {tree && (
        <AccordionNode
          node={tree}
          onSelect={handleSelect}
          selectedTag={selectedTag}
          reloadTree={loadTree}
          projectId={projectId}
          sessionNo={sessionNo}
          openNodes={openNodes}
          setOpenNodes={setOpenNodes}
        />
      )}
    </div>
  );
};

export default TreeView;